import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var SET_LOOKBOOK = 'SET_LOOKBOOK';
export var SET_LOADING_AMBIENCES = 'SET_LOADING_AMBIENCES';
export var APPEND_AMBIENCES = 'APPEND_AMBIENCES';
export var PREPEND_AMBIENCES = 'PREPEND_AMBIENCES';